import React, { FC } from "react";
import classNames from "classnames/dedupe";
import MediaBuilder, {
  TImageData,
} from "../../Utility/MediaBuilder/MediaBuilder";
import { IWidgetMedia } from "./WidgetMedia.interface";

/** Was needed to reduce `PromoWidget`'s complexity */
const WidgetMedia: FC<IWidgetMedia> = ({ classes = {}, mediaData, ratio }) => (
  <div className={`${classes?.root || classes?.ratio || ""}`}>
    <MediaBuilder
      {...(mediaData as TImageData)}
      data={{
        ...((mediaData as TImageData).data || {}),
        ...([undefined, "image"].includes((mediaData as TImageData).type)
          ? {
              ratio: ratio || mediaData.ratio,
              classes: {
                ...((mediaData as TImageData).data?.classes || {}),
                ratio: classNames(
                  "ratio--full-height",
                  (mediaData as TImageData).data?.classes?.ratio,
                  classes?.ratio,
                ),
              },
            }
          : {}),
      }}
    />
  </div>
);

export default WidgetMedia;
